module.exports = require("@swa-ui/core/assets/styles/globalRules.module.scss");